import { GraduationCap } from "lucide-react";

const StudentsTileDesign = {
  id: "students",
  icon: GraduationCap,
  label: "Students",
  background: "linear-gradient(135deg, var(--color-primary-dark), var(--color-primary))",
  color: "#ffffff",
};

export default StudentsTileDesign;
